<template>
  <div class="one-card">
    <div style="padding: 0 10px">
      <piczoom :src="getSrc">
        <img style="width: 414px; height: 340px" :src="getSrc" />
      </piczoom>
    </div>
    <div>
      <ul class="u-myflex u-color-white u-flexwrap">
        <li class="u-w-100"><span>姓名：</span>{{ data.name }}</li>
        <li class="u-w-100"><span>性别：</span>{{ data.sex }}</li>
        <li class="u-w-100"><span>身份证号：</span>{{ data.idcard }}</li>
        <li class="u-w-100"><span>年龄：</span>{{ data.age }}</li>
        <li class="u-w-100"><span>所属企业：</span>{{ data.personCompany }}</li>
        <li class="u-w-100">
          <span>所属部门：</span>{{ data.departmentName }}
        </li>
        <li class="u-w-100">
          <span>通行人员类型：</span
          >{{
            data.personType == 1
              ? '企业通行人员'
              : data.personType == 2
              ? '临时通行人员'
              : '重点人员'
          }}
        </li>
        <li class="u-w-100">
          <span>通行时间：</span>{{ data.passingTimeFormat }}
        </li>
        <li class="u-w-100"><span>闸机设备：</span>{{ data.deviceName }}</li>
        <li class="u-w-100"><span>闸机卡口：</span>{{ data.tollgateName }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import piczoom from '@/components/piczoom.vue';

export default {
  name: 'OneCard',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    piczoom
  },
  computed: {
    getSrc() {
      return this.data.storageUrl1 || this.data.imgsrc;
    }
  }
};
</script>

<style lang="scss" scoped>
.one-card {
  display: flex;
  ul {
    li {
      text-align: left;
      padding: 6px 0;
      color: #e1e1e1;
      span {
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  > div {
    flex: 1;
    text-align: center;
  }
}

.font-bold {
  font-weight: bold;
  padding: 6px 0;
  font-size: 16px;
  color: #403f3f;
}
</style>


// WEBPACK FOOTER //
// src/components/cards-info/one-card.vue